import script from "./LangModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LangModal.vue?vue&type=script&setup=true&lang=js"

import "./LangModal.vue?vue&type=style&index=0&id=5ed5d117&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed5d117"]])

export default __exports__